export const GROUP_DELETE_MEMBER = "userManagement/groupDeleteMember";
export const CREATE_GROUP = "userManagement/createGroup";
export const GROUP_ADD_MEMBER = "userManagement/groupAddMember";
export const DELETE_GROUP = "userManagement/deleteGroup";
export const UPDATE_GROUP = "userManagement/updateGroup";
export const EXPORT_GROUP_MEMBERS_EXCEL =
  "userManagement/exportGroupMembersExcel";
export const EXPORT_ALL_GROUP_MEMBERS_EXCEL =
  "userManagement/exportAllGroupMembersExcel";
